<template>
  <div class="tipo-regra-cards">
    <div class="tipo-regra-cards__grid">
      <SelectableCard
        v-for="opcao in opcoesFiltradas"
        :key="opcao.value"
        :value="opcao.value"
        :label="opcao.label"
        :description="opcao.description"
        :icon="opcao.icon"
        :selected="value === opcao.value"
        :disabled="disabled || opcao.disabled"
        @select="$emit('input', $event)"
      />
    </div>
  </div>
</template>

<script>
import SelectableCard from "./SelectableCard.vue";
import { TIPO_LABELS } from "../helpers/campanhaLabels";

export default {
  name: "TipoRegraCards",
  components: { SelectableCard },
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validacao: {
      type: String,
      default: "",
    },
  },
  computed: {
    opcoesFiltradas() {
      return Object.entries(TIPO_LABELS).map(([key, config]) => ({
        value: key,
        label: config.label,
        description: config.description,
        icon: config.icon,
        disabled:
          (key === "PERSONALIZADO" || key === "MIX") &&
          (this.validacao === "PM" || this.validacao === "PMD"),
      }));
    },
  },
};
</script>

<style scoped>
.tipo-regra-cards__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

@media (max-width: 768px) {
  .tipo-regra-cards__grid {
    grid-template-columns: 1fr;
  }
}
</style>
